import { render, staticRenderFns } from "./RubricForm.vue?vue&type=template&id=58986684&scoped=true"
import script from "./RubricForm.vue?vue&type=script&lang=js"
export * from "./RubricForm.vue?vue&type=script&lang=js"
import style0 from "./RubricForm.vue?vue&type=style&index=0&id=58986684&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58986684",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58986684')) {
      api.createRecord('58986684', component.options)
    } else {
      api.reload('58986684', component.options)
    }
    module.hot.accept("./RubricForm.vue?vue&type=template&id=58986684&scoped=true", function () {
      api.rerender('58986684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/rubric/form/RubricForm.vue"
export default component.exports